/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum UploadDocumentConflictType {
  UserVerificationNotFound = 'user_verification_not_found',
  DocumentAlreadyUploaded = 'document_already_uploaded'
}
